import { useTranslation } from 'react-i18next';

import { useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';

import { CreateEstateModal } from '@/components/modals/create-estate-modal';
import { useModal } from '@/components/modals/new/use-modal';
import { Button } from '@/components/new-ui/button';

/** "New Estate" button of the estates page, opens the same modal as the header "+" menu. */
export const EstatesNewEstateButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const modal = useModal();

  return (
    <>
      <Button type="button" className="gap-2" onClick={() => modal.open()}>
        <Plus className="h-4 w-4" />
        {t('newEstate')}
      </Button>
      <CreateEstateModal navigate={navigate} modal={modal} />
    </>
  );
};
